import { useEffect } from 'react'
import { supabase } from '@/lib/supabase'
import { useUIStore } from '@/stores/ui'

/**
 * Hook to sync user preferences with Supabase auth state
 * Automatically loads preferences on login and clears on logout
 */
export function useAuthSync() {
  const { syncPreferencesFromSupabase } = useUIStore()

  useEffect(() => {
    // Load preferences on initial load if user is authenticated
    const loadInitialPreferences = async () => {
      const { data: { user } } = await supabase.auth.getUser()
      if (user) {
        await syncPreferencesFromSupabase()
      }
    }

    loadInitialPreferences()

    // Listen for auth state changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        if (event === 'SIGNED_IN' && session?.user) {
          // User signed in - load their preferences from Supabase
          await syncPreferencesFromSupabase()
        } else if (event === 'SIGNED_OUT') {
          // User signed out - preferences will remain in localStorage as fallback
          // but won't sync to Supabase until next login
          console.log('User signed out - preferences now localStorage only')
        }
      }
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [syncPreferencesFromSupabase])
}